const algorithm = "aes-256-ctr";
const secretKey = "vOhv6sdmpNWjrRIqCc0rdxs71lwHzfr3";

module.exports = {
    algorithm,
    secretKey,
};
